import { Card, Grid, styled } from '@mui/material';
import Column from 'src/frontend-common/components/Column';

export const CardWrapper = styled(Grid)(({ theme }) => ({
  marginBottom: theme.spacing(2),
  [theme.breakpoints.down('md')]: {
    '&>div': {
      marginBottom: theme.spacing(3),
    },
  },
  '& h5': {
    color: theme.typography.body2.color,
  },
}));

export const WelcomeCard = styled(Card)(({ theme }) => ({
  height: '100%',
  position: 'relative',
  '&>div': {
    padding: theme.spacing(3),
    height: 'calc(100% - 70px)',
    '& h3': {
      fontSize: 24,
      fontWeight: 600,
      lineHeight: '120%',
      letterSpacing: '-0.06px',
      color: theme.palette.text.primary,
      marginTop: theme.spacing(2),
      marginBottom: 0,
    },
    '& h4': {
      fontSize: 14,
      fontWeight: 400,
      lineHeight: '120%',
    },
    '& h5': {
      fontSize: 16,
      fontWeight: 600,
      lineHeight: '120%',
      letterSpacing: '-0.05px',
      marginBottom: theme.spacing(1.25),
    },
    '& p': {
      fontSize: 14,
      fontWeight: 400,
      lineHeight: '120%',
      letterSpacing: '-0.06px',
    },
    '& img': {
      width: 20,
      height: 20,
    },
    '&:last-of-type': {
      padding: theme.spacing(2, 3),
      borderTop: `1px solid ${theme.palette.grey[50]}`,
      height: 70,
      display: 'flex',
      '& a': {
        textDecoration: 'none',
        color: theme.palette.primary.main,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        fontSize: 13,
        fontWeight: 500,
        lineHeight: '175%',
        letterSpacing: '0.46px',
        '& svg': {
          width: 16,
          height: 16,
          marginLeft: theme.spacing(1),
        },
      },
    },
  },
}));

export const UsageCostWrapper = styled(Column)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  [theme.breakpoints.down('md')]: {
    height: 'auto',
  },
  '&>h3': {
    fontSize: 16,
    padding: theme.spacing(3),
  },
  '& p': {
    fontSize: 14,
    fontWeight: 400,
    lineHeight: '120%',
    letterSpacing: '0.25px',
  },
  '&>div': {
    display: 'flex',
    flexDirection: 'row',
    '&:first-of-type': {
      backgroundColor: theme.palette.background.default,
      textTransform: 'uppercase',
      fontWeight: 500,
    },
    '&>div': {
      width: '25%',
      display: 'flex',
      justifyContent: 'flex-end',
      '&:first-of-type': {
        width: '50%',
        justifyContent: 'flex-start',
      },
    },
  },
}));
